import { Link } from '@reach/router'
import React from 'react'
import './categorie-header.scss'

interface CategorieHeaderProps {
  subcategorie?: {
    title: string
    slug: string
  }[]
  departamentSlug: string
  categorieSlug: string
  closeMenu?: () => void
  categorieTitle: string
  setCurrentCategorie?: (currentCategorie: string) => void
  currentCategorie: string
}

export const CategorieHeader = ({
  closeMenu,
  departamentSlug,
  categorieSlug,
  categorieTitle,
  setCurrentCategorie,
  currentCategorie,
  subcategorie,
}: CategorieHeaderProps) => {
  const singleCategorieTitle = `${categorieTitle}-categorie-title`
  const hasRestriction = !!(!subcategorie || subcategorie?.length <= 0)

  return (
    <div className="desktop-menu-categorie-header">
      <Link
        onClick={() => {
          closeMenu?.()
          setCurrentCategorie?.(singleCategorieTitle)
        }}
        to={`/${departamentSlug}/${categorieSlug}`}
        data-store-link
      >
        <span
          className={`${hasRestriction ? 'restriction-title' : ''} ${
            currentCategorie === singleCategorieTitle ? 'currentCategorie' : ''
          } ${
            hasRestriction && currentCategorie === singleCategorieTitle
              ? 'restriction-title-open'
              : ''
          }`}
        >
          {categorieTitle}
        </span>
      </Link>
    </div>
  )
}
